/**
 * @desc 拍品模块
 */
import { goodsAxios, goodsAxiosDirect } from '../httpInstance';
// desc 搜索车辆管理下各个状态车辆数量
export const getTabStatisticsCount = (params) => {
    return goodsAxios({
        url: 'getTabStatisticsCount',
        method: 'GET',
        params,
    });
};
// desc 搜索可添加车辆(场次中使用)
export const queryCar = (params) => {
    return goodsAxios({
        url: 'queryCar',
        method: 'GET',
        params,
    });
};
// 首页-当月累计申请车辆
export const getApplyCarCount = (params) => {
    return goodsAxios({
        url: 'getApplyCarCount',
        method: 'GET',
        params,
    });
};
// 首页-当月累计成交车辆
export const getDealedCarCount = (params) => {
    return goodsAxios({
        url: 'getDealedCarCount',
        method: 'GET',
        params,
    });
};
// 首页-首页车辆发拍待审批的列表
export const getIndexList = (params) => {
    return goodsAxios({
        url: 'getIndexList',
        method: 'GET',
        params,
    });
};
// desc 查询全部审批列表
export const getApproveCar = (params) => {
    return goodsAxios({
        url: 'queryApproveCar',
        params,
    });
};
// desc 查询我的审批列表
export const queryMyGoodsAuditList = (params) => {
    return goodsAxios({
        url: 'queryMyGoodsAuditList',
        params,
    });
};
// desc 通过审批
export const throughApprove = (data) => {
    return goodsAxios({
        url: 'throughApprove',
        method: 'POST',
        data,
    });
};
// desc 分配人员
export const distributionAudit = (data) => {
    return goodsAxios({
        url: 'distributionAudit',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify(data),
    });
};
// desc 撤回审批
export const revocationAuditById = (data) => {
    return goodsAxios({
        url: 'revocationAuditById',
        method: 'POST',
        data,
    });
};
// desc 驳回审批
export const disapprovalAuditById = (data) => {
    return goodsAxios({
        url: 'disapprovalAuditById',
        method: 'POST',
        data,
    });
};
// desc 车辆状态列表-审批状态列表
export const getCarInfoListByAuditStatus = (params) => {
    return goodsAxios({
        url: 'getCarInfoListByAuditStatus',
        params,
    });
};
// desc 车辆状态列表-车辆状态列表
export const getCarInfoListByStatus = (params) => {
    return goodsAxios({
        url: 'getCarInfoListByStatus',
        params,
    });
};
// desc 流拍记录
export const queryCarLossListByGoodsId = (params) => {
    return goodsAxios({
        url: 'queryCarLossListByGoodsId',
        ['hideLoading']: true,
        params,
    });
};
// desc 车辆详情
export const getCarInfoByGoodsId = (params) => {
    return goodsAxios({
        url: 'getCarInfoByGoodsId',
        params,
    });
};
// 流拍车辆列表
export function flowAuctionList(payload) {
    return goodsAxios({
        url: 'flowAuctionList',
        method: 'get',
        params: payload,
    });
}
// 流拍车辆确认交易失败
export function confirmFailTrade(data) {
    return goodsAxios({
        method: 'post',
        url: 'confirmFailTrade',
        data,
    });
}
/**
 * 车辆管理-交易结束车辆/下线车辆
 * */
// 获取交易结束车辆列表
export const getTradeFailedCars = (params) => {
    return goodsAxios({
        url: 'getTradeFailedCars',
        params,
    });
};
// 交易结束列表根据拍品ID操作退回流拍
export const backAbortiveByIdList = (data) => {
    return goodsAxios({
        method: 'post',
        url: 'backAbortiveByIdList',
        data,
    });
};
// 查询交易成功车辆列表
export const getTradeSuccessedCars = (params) => {
    return goodsAxios({
        url: 'getTradeSuccessedCars',
        params,
    });
};
// 下线车辆
export const getOffLineCars = (params) => {
    return goodsAxios({
        url: 'getOffLineCars',
        params,
    });
};
// desc 导出
export const globalExport = (params) => {
    return goodsAxiosDirect({
        url: 'goodsExport',
        method: 'POST',
        responseType: 'blob',
        data: params,
    });
};
// desc 查询过户信息
export const getCustomerServiceByGoodsId = (goodsId) => {
    return goodsAxios({
        url: 'getCustomerServiceByGoodsId',
        method: 'GET',
        params: {
            goodsId,
        },
    });
};
